/**
 * 即梦 4.5（doubao-seedream-4-5-251128）manifest
 * 数据来源：image.json field_map
 * 特点：2K/4K 两档清晰度，各档比例带真实像素；参考图上限 6；提交前有生成图尺寸校验（转写自现有硬编码）
 */
import type { ImageModelConfig } from '../../types';

export const jimeng4_5: ImageModelConfig = {
  id: '01KEXWJB94JDK6T9TW0QPY1RM8',
  displayName: '即梦 4.5',

  defaults: {
    ratio: '9:16', // 2K 档 select: true 项
    resolution: '2K', // 接口 resolution.default
  },

  ratioOptions: {
    '2K': [
      { label: '1:1', value: '1:1', width: 2048, height: 2048 },
      { label: '2:3', value: '2:3', width: 1664, height: 2496 },
      { label: '3:2', value: '3:2', width: 2496, height: 1664 },
      { label: '3:4', value: '3:4', width: 1728, height: 2304 },
      { label: '4:3', value: '4:3', width: 2304, height: 1728 },
      { label: '9:16', value: '9:16', width: 1440, height: 2560 },
      { label: '16:9', value: '16:9', width: 2560, height: 1440 },
      { label: '21:9', value: '21:9', width: 3024, height: 1296 },
    ],
    '4K': [
      { label: '1:1', value: '1:1', width: 4096, height: 4096 },
      { label: '2:3', value: '2:3', width: 3342, height: 5013 },
      { label: '3:2', value: '3:2', width: 5013, height: 3342 },
      { label: '3:4', value: '3:4', width: 3543, height: 4724 },
      { label: '4:3', value: '4:3', width: 4724, height: 3543 },
      { label: '9:16', value: '9:16', width: 3072, height: 5461 },
      { label: '16:9', value: '16:9', width: 5461, height: 3072 },
      { label: '21:9', value: '21:9', width: 6252, height: 2683 },
    ],
  },

  resolutionOptions: [
    { label: '高清 2K', value: '2K' },
    { label: '超清 4K', value: '4K' },
  ],
  resolutionLabel: '图片质量', // 接口 field_map.resolution.label

  qualityOptions: [],

  toggles: {},

  limits: {
    maxRefImages: 6, // 接口 field_map.ref_images.max
    // 生成图尺寸校验（转写自 handleGenerate 现有硬编码：宽×高 ∈ [3686400, 16777216]、宽/高 ∈ [1/16, 16]）
    generationConstraints: {
      pixelCount: { min: 3686400, max: 16777216 },
      aspectRatio: { min: 1 / 16, max: 16 },
      pixelCountErrorKey: 'imageCreation.imageSizeInvalid2', // 原即梦 4.5 专属文案
    },
  },
};
